var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComercio28X28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19654 4.69727C3.66219 4.69727 3.22901 5.13045 3.22901 5.6648V17.858C3.22901 18.3923 3.66219 18.8255 4.19654 18.8255H23.7802C24.3146 18.8255 24.7477 18.3923 24.7477 17.858V5.6648C24.7477 5.13045 24.3146 4.69727 23.7802 4.69727H4.19654ZM1.48047 5.6648C1.48047 4.16476 2.69649 2.94873 4.19654 2.94873H23.7802C25.2803 2.94873 26.4963 4.16476 26.4963 5.6648V17.858C26.4963 19.358 25.2803 20.574 23.7802 20.574H4.19654C2.69649 20.574 1.48047 19.358 1.48047 17.858V5.6648Z",
    fill: "#FF655A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8478 19.4723C10.9506 19.0907 11.2967 18.8255 11.692 18.8255H16.2848C16.6801 18.8255 17.0261 19.0907 17.129 19.4723L18.3413 23.9719C18.4121 24.2346 18.3565 24.5152 18.1911 24.7311C18.0257 24.947 17.7691 25.0736 17.4971 25.0736H10.4796C10.2076 25.0736 9.95111 24.947 9.78566 24.7311C9.62022 24.5152 9.5647 24.2346 9.63547 23.9719L10.8478 19.4723ZM12.3619 20.574L11.6206 23.3251H16.3561L15.6149 20.574H12.3619Z",
    fill: "#FF655A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34142 24.1994C6.34142 23.7165 6.73284 23.3251 7.21569 23.3251H20.7611C21.2439 23.3251 21.6353 23.7165 21.6353 24.1994C21.6353 24.6822 21.2439 25.0736 20.7611 25.0736H7.21569C6.73284 25.0736 6.34142 24.6822 6.34142 24.1994Z",
    fill: "#FF655A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48047 15.4333C1.48047 14.9505 1.87189 14.5591 2.35474 14.5591H25.622C26.1049 14.5591 26.4963 14.9505 26.4963 15.4333C26.4963 15.9162 26.1049 16.3076 25.622 16.3076H2.35474C1.87189 16.3076 1.48047 15.9162 1.48047 15.4333Z",
    fill: "#FF655A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComercio28X28);
export default __webpack_public_path__ + "static/media/COMERCIO_28X28.a8ea41c546178546cdcea20e7048d08e.svg";
export { ForwardRef as ReactComponent };